import e from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import g from "./iconfont.es5471.js";
const r = {
  display: "block"
}, s = ({ size: a = 16, useVw: n, useRem: l, color: c, withColor: o, removeClassName: t, disableSSR: m, style: i, ...p }) => {
  const f = i ? { ...r, ...i } : r;
  return /* @__PURE__ */ e.createElement(g, { disableSSR: m }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "32px-jingjishangfuwu", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (l ? "rem" : "px"), height: n ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (l ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: f, fill: "none", ...p }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "32px-ç»çºªåæå¡"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: o ? d(c, 0, "#262933") : "#262933",
        datafollowfill: o ? d(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M20.33 9.19a5.19 5.19 0 1 1-10.38 0 5.19 5.19 0 0 1 10.38 0Zm-1.8 0a3.39 3.39 0 1 1-6.78 0 3.39 3.39 0 0 1 6.78 0Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M7.4 23.19a4.778 4.778 0 0 1 4.778-4.779h1.655a.9.9 0 1 0 0-1.8h-1.655A6.578 6.578 0 0 0 5.6 23.19v3.494a.9.9 0 1 0 1.8 0V23.19Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M18.984 18.692c.945-.378 2.188-.592 3.516-.592 1.328 0 2.572.214 3.516.592.47.188.91.434 1.249.753.34.322.635.78.635 1.355 0 .576-.295 1.033-.635 1.354-.338.32-.779.567-1.249.754-.944.378-2.188.592-3.516.592-1.328 0-2.571-.214-3.516-.592-.47-.188-.91-.434-1.249-.754-.34-.32-.635-.778-.635-1.354 0-.576.295-1.033.635-1.355.338-.32.779-.566 1.249-.753Zm-.092 2.157.002-.005v.003l-.002.002Zm.035-.049a.659.659 0 0 1 .045-.047c.118-.11.336-.252.68-.39.684-.274 1.69-.463 2.848-.463s2.164.19 2.848.463c.344.138.563.28.68.39.02.018.034.034.045.047a.659.659 0 0 1-.045.047c-.117.11-.336.252-.68.39-.684.274-1.69.463-2.848.463-1.157 0-2.164-.19-2.848-.463-.344-.138-.562-.28-.68-.39a.659.659 0 0 1-.045-.047ZM18 24.1a.9.9 0 0 1 .9.864c.01.016.03.043.072.083.118.11.336.252.68.39.684.274 1.69.463 2.848.463s2.164-.19 2.848-.463c.344-.138.563-.28.68-.39a.472.472 0 0 0 .073-.082.9.9 0 0 1 1.8.035c0 .576-.296 1.033-.636 1.355-.338.32-.779.566-1.249.753-.944.378-2.188.592-3.516.592-1.328 0-2.571-.214-3.516-.592-.47-.188-.91-.434-1.249-.753-.34-.322-.635-.78-.635-1.355a.9.9 0 0 1 .9-.9Zm8.106.856.002-.005v.001l-.002.004Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, x = s;
export {
  x as default
};
